/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dry_Soft_Crow_WakeInputs */

const en_dry_soft_crow_wake = /** @type {(inputs: Dry_Soft_Crow_WakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Insights`)
};

const de_dry_soft_crow_wake = /** @type {(inputs: Dry_Soft_Crow_WakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Insights`)
};

/**
* | output |
* | --- |
* | "AI Insights" |
*
* @param {Dry_Soft_Crow_WakeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dry_soft_crow_wake = /** @type {((inputs?: Dry_Soft_Crow_WakeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dry_Soft_Crow_WakeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dry_soft_crow_wake(inputs)
	return de_dry_soft_crow_wake(inputs)
});